/* =================== DETALHE PRODUTO =================== */
jQuery(document).ready(function ($) {
  var dots = $('.produto-detalhe-fotos-destaque li').length > 1;
  // Carrosel fotos
  $('.produto-detalhe-fotos-destaque').slick({
    slidesToShow: 1,
    infinite: false,
    dots: false,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.produto-detalhe-fotos-thumbs',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          dots: false,
          arrows: false,
        },
      },
    ],
  });

  // Carrosel thumbs
  $('.produto-detalhe-fotos-thumbs').slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    focusOnSelect: true,
    arrows: false,
    asNavFor: '.produto-detalhe-fotos-destaque',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  // Categorias Mobile
  $('#produtos-cat').on('change', alteraCampoCat);

  function alteraCampoCat() {
    const categoria = $('#produtos-cat').val();
    location.href = categoria;
  }
});

/* =================== ENVIA ORÇAMENTO =================== */
jQuery(document).ready(function ($) {
  var enviando_formulario = false;
  $('#form-orcamento').on('submit', function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = form.find('#enviar');
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr('disabled', false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr('action'),
        type: form.attr('method'),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
          enviando_formulario = true;
          submit_btn.attr('disabled', true);
          submit_btn.text('Enviando...');
        },
        success: function (data) {
          console.log(data);
          volta_submit();
          if (data == 'ok') {
            closeModal('modal-orcamento');
            $('#form-orcamento .campo').val('');
            showAlert(
              'Sucesso',
              'Sua mensagem foi enviada com sucesso.',
              'success',
            );
          } else {
            showAlert('Erro', 'Não foi possível enviar a mensagem.', 'error');
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert('Erro', 'Não foi possível enviar a mensagem.', 'error');
          console.log('ajax error response type ' + type);
        },
      });
    }
  });
});
